import React from "react";
// import flexible from '../../utils/flexible';
import "./index.less";
import contentImg from "./img/content.png";
import content1Img from "./img/content1Img.png";

class AboutUs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    // document.title = '关于绿色慧联';
    return (
      <div className="page_type_h5">
        <div id="aboutUs">
          <section className="no-one">
            <h3></h3>
            <p>
              定位于绿色运力和智慧车联网平台提供商，注册资本15亿元，总部位于浙江杭州。
            </p>
            <p>
              绿色慧联以场景定制为核心，为客户提供慧联租车、慧管车、慧充电、慧运力等新能源商用车全生命周期运营管理服务，秉承慧联人的激情、梦想、拼搏、创新精神，致力于打造绿色运力共享平台，建立绿色联盟，为推动绿色物流和智慧物流发展而努力。
            </p>
          </section>
          <section className="no-two">
            <h3></h3>
          </section>
          <section className="no-three">
            {/* <img src="https://image.tf56.com/dfs/group1/M00/58/11/CiFBCVsjTNCAX5glAAVk5klbgm4770.png" alt="" /> */}
            <img src={contentImg} alt="" />
          </section>
          <section className="no-four">
            <h3></h3>
            <p>
              “HIC慧联智控”是绿色慧联为实现人、车、货闭环，构建城市绿色运力而打造的智慧车联网平台。而
              <span className="emphasis">“远程慧联APP”</span>
              是绿色慧联平台服务于与司机的移动客户端，司机可以通过APP
              <span className="emphasis">
                找桩充电、线上租车、找服务站、寻找货源
              </span>
              等服务。
            </p>
          </section>
          <section className="no-five">
            {/* <img
              src="https://image.tf56.com/dfs/group1/M00/70/B7/CiFCK2CCIOeAEgNhAAEn-VJUSNo194.png"
              alt=""
            /> */}
            <img src={content1Img} alt="" />
          </section>
          <section className="no-six">
            <h3></h3>
            <p>如遇问题，请联系我们。联系电话：</p>
            <p>
              <a href="tel:4008262266">400-826-2266</a> ;{" "}
              <a href="tel:057182899926">0571-82899926</a>
            </p>
          </section>
        </div>
      </div>
    );
  }
}

export default AboutUs;



// WEBPACK FOOTER //
// ./src/staticPage/aboutUs/index.js